/** Standard US mattress footprints (inches) for layout comparison visuals. */

export type BlissBasicMattressSizeId = 'twin' | 'full' | 'queen'

export type BlissBasicMattressSize = {
  id: BlissBasicMattressSizeId
  label: string
  widthIn: number
  lengthIn: number
}

export const BLISS_BASIC_MATTRESS_SIZES: Record<BlissBasicMattressSizeId, BlissBasicMattressSize> = {
  twin: { id: 'twin', label: 'Twin', widthIn: 38, lengthIn: 75 },
  full: { id: 'full', label: 'Full', widthIn: 54, lengthIn: 75 },
  queen: { id: 'queen', label: 'Queen', widthIn: 60, lengthIn: 80 },
}

export type BlissBasicLayoutVizSpec =
  | { type: 'stack'; /** bottom → top */ layers: BlissBasicMattressSizeId[] }
  | { type: 'corner'; bed: BlissBasicMattressSizeId; count: 4 }
  | { type: 'unsure' }

/** Maps Bliss Basic layout / model choice keys to mattress diagrams. */
export const BLISS_BASIC_LAYOUT_VIZ: Record<string, BlissBasicLayoutVizSpec> = {
  twin_full: { type: 'stack', layers: ['full', 'twin'] },
  full_full: { type: 'stack', layers: ['full', 'full'] },
  triple_stack: { type: 'stack', layers: ['twin', 'twin', 'twin'] },
  quad_corner: { type: 'corner', bed: 'twin', count: 4 },
  not_sure: { type: 'unsure' },
}

export function blissBasicLayoutVizForChoice(choiceKey: string): BlissBasicLayoutVizSpec {
  return BLISS_BASIC_LAYOUT_VIZ[choiceKey] ?? { type: 'unsure' }
}

export function mattressFootprintLabel(id: BlissBasicMattressSizeId): string {
  const m = BLISS_BASIC_MATTRESS_SIZES[id]
  return `${m.label} · ${m.widthIn}×${m.lengthIn}"`
}
